<template>
  <div class="big couponGroup-statistics">
    <div class="page_title flex between">
      <span>券包统计-{{ $route.query.group_coupon_name }}</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div class="container" style="padding: 10px 20px 20px 20px">
      <div class="search-box">
        <!-- 领取用户手机号 -->
        <div class="item">
          <span>领取用户手机号</span>
          <div class="item-content">
            <el-input
              v-model="searchForm.phone"
              size="small"
              clearable
              @keyup.enter.native="seachEnterFun"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>

        <!-- 领取时间 -->
        <div class="item" style="margin: 0 10px;">
          <span>领取时间</span>
          <div class="item-content">
            <el-date-picker
              v-model="searchForm.times"
              clearable
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
            >
            </el-date-picker>
          </div>
        </div>

        <!-- 优惠券名 -->
        <div class="item">
          <span>优惠券名</span>
          <div class="item-content">
            <el-input
              v-model="searchForm.coupon_name"
              size="small"
              clearable
              @keyup.enter.native="seachEnterFun"
              placeholder="请输入"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="small"
            style="margin-left: 20px"
            @click="searchBtn"
            >查询</el-button
          >
        </div>
      </div>
      <div class="count-data">
        <div>领取次数:{{ count_data.receive_num }}</div>
        <div>领取用户数:{{ count_data.receive_user_num }}</div>
        <div>
          领取优惠券数:{{
            Number(count_data.shop_receive_num) +
              Number(count_data.console_receive_num)
          }}（诊疗:{{ count_data.console_receive_num }}&nbsp;商城:{{
            count_data.shop_receive_num
          }}）
        </div>
        <div>
          已使用优惠券:{{
            Number(count_data.shop_used_num) +
              Number(count_data.console_used_num)
          }}（诊疗:{{ count_data.console_used_num }}&nbsp;商城:{{
            count_data.shop_used_num
          }}）
        </div>
        <div>
          诊疗订单实付总金额:{{ count_data.console_pay_money }}（抵口金额：{{
            count_data.console_coupon_money
          }}）
        </div>
        <div>
          商城订单实付总金额:{{ count_data.shop_pay_money }}（抵口金额：{{
            count_data.shop_coupon_money
          }}）
        </div>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          v-loading="tableLoading"
          :data="couponList"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            v-for="item in tableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'receive_time'">
                {{ scope.row[item.prop] | dateTimeFormat }}
              </div>

              <div v-else-if="item.prop == 'used'">
                {{ scope.row[item.prop] | usedText }}
              </div>

              <div v-else-if="item.prop == 'order_sn'">
                <el-link
                  v-for="(item, index) in scope.row[item.prop]"
                  :key="index"
                  type="primary"
                  @click="toPage(scope.row)"
                  >{{ item }}</el-link
                >
              </div>

              <div v-else-if="item.prop == 'pay_money'">
                <div v-for="(item, index) in scope.row[item.prop]" :key="index">
                  {{ item }}
                </div>
              </div>

              <div v-else-if="item.prop == 'coupon_money'">
                <div v-for="(item, index) in scope.row[item.prop]" :key="index">
                  {{ item }}
                </div>
              </div>

              <div v-else>
                {{ !scope.row[item.prop] ? "------" : scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <pagination
        v-show="totalNum > 0"
        :total="totalNum"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      searchForm: {
        times: "",
        coupon_name: "",
        phone: "",
      },
      count_data: {
        receive_num: "",
        receive_user_num: "",
        console_receive_num: "",
        shop_receive_num: "",
        console_used_num: "",
        shop_used_num: "",
        console_pay_money: "",
        console_coupon_money: "",
        shop_pay_money: "",
        shop_coupon_money: "",
      },
      tableHeader: [
        {
          label: "券包名称",
          prop: "group_coupon_name",
          width: "180",
          align: "center",
          fixed: "left",
        },
        {
          label: "领取时间",
          prop: "receive_time",
          width: "180",
          align: "center",
          fixed: false,
        },
        {
          label: "领取用户昵称",
          prop: "nick_name",
          width: "300",
          align: "center",
          fixed: false,
        },
        {
          label: "领取用户手机号",
          prop: "phone",
          width: "300",
          align: "center",
          fixed: false,
        },
        {
          label: "优惠券名",
          prop: "coupon_name",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "状态",
          prop: "used",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "关联订单",
          prop: "order_sn",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "订单实付金额",
          prop: "pay_money",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "抵扣金额",
          prop: "coupon_money",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      couponList: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    dateTimeFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    usedText(val) {
      switch (val) {
        case 0:
          return "未使用";
        case 1:
          return "已使用";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    // 查询
    searchBtn() {
      this.pagination.page = 1;
      this.getList();
    },
    getList() {
      let group_id = this.$route.query.group_id;
      let params = Object.assign(
        { group_id },
        this.pagination,
        this.searchForm
      );
      let times = this.searchForm.times;
      params.start_time = times ? times[0] : "";
      params.end_time = times ? times[1] : "";
      this.tableLoading = true;
      marketing.platformCouponGroupStatistics(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          if (this.pagination.page == 1) {
            this.count_data = data.count_data;
          }
          this.couponList = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    // 跳转关联订单
    toPage(row) {
      let { type_order } = row;
      let path = "";
      let query = {};
    
      switch (type_order) {
        case 1:
          // 商城订单
          path = "/home/shoppingmall/orderdetail";
          query = {
            order_id: row.order_id,
          };
          break;
        // case 2:
        //   // 问诊
        //   path = "/home/yewu/wenzhendetail";
        //   query = {
        //     consult_id: row.consult_id,
        //     consult_types: row.consult_types,
        //   };
        //   break;
        case 3:
          // 处方
          path = "/home/order/orderdetail";
          query = {
            order_id: row.order_id,
          };
          break;
      }
      this.$router.push({
        path,
        query,
      });
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.couponGroup-statistics {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
  .count-data {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 20px;
    & > div {
      margin-right: 16px;
    }
  }
}
</style>
